<template>
  <v-base-card>
    <template v-slot:heading>
      規約
    </template>
    <template v-slot:content>
      <p class="env-text mb-2">ブラウザ：Windows→Google Chrome ／ Microsoft Edge (Chromium版)、Mac→Safari（最新版）</p>
      <h2 class="mb-8" style="margin-bottom:10px;">
        ゲットスルー2600 システム
      </h2>

      <!-- ご注意点 -->
      <h5 style="margin-bottom:10px;">
        ≪ご注意点≫
      </h5>
      <p class="bold mx-0 mb-0">①	本システムは、1教室につき、月々3,000円（+税）・年間30,000円（+税）での販売となります。</p>
      <p class="bold mx-0 mb-0">②	1教室につき1IDを発行いたしますので、教室登録は必ず行ってください。</p>
      <p class="bold mx-0 mb-0">③	登録については「申込方法」をご確認ください。</p>

      <!-- 申込方法 -->
      <h5 class="mt-8" style="margin-bottom:10px;">
        ≪申込方法≫
      </h5>
      <p class="mb-0">①	申し込みフォームにて、基本情報の必要事項をすべて入力してください</p>
      <p class="mb-0">② 「1.お客様No」は、弊社営業所及び弊社特約店から教材をご購入時に使用している番号をご入力ください</p>
      <p class="ml-4 mb-0">※弊社特約店よりご購入のお客様は、お客様No.が別設定の場合がございますので、ご登録前に弊社特約店にご確認ください</p>
      <p class="mb-0">③ 「個人情報の取り扱いについて」を確認後、チェックを入れます</p>
      <p class="mb-0">④ 入力後「確認」、「申し込みを確定する」で申し込みが完了します</p>

      <!-- ご利用期間について -->
      <h5 class="mt-8" style="margin-bottom:10px;">
        ≪ご利用期間について≫
      </h5>
      <p class="mb-0 ml-3"><font style="font-weight:bold">-「月々」の場合</font></p>
      <p class="mb-0">お申し込みいただいた月の末日までご利用可能となります。</p>
      <p class="mb-0">解約の申し込みがない限り、1ヶ月単位の自動更新となります。</p>
      <p class="mt-5 mb-0 ml-3"><font style="font-weight:bold">-「年間」の場合</font></p>
      <p class="mb-0">お申し込みいただいた月を含めた12ヶ月のご契約となります。</p>
      <p class="mb-0">例：4月10日にお申し込み→翌年3月31日までご利用可能</p>
      <p class="mb-0">解約の申し込みがない限り、毎年自動更新となります。</p>

      <!-- 解約について -->
      <h5 class="mt-8" style="margin-bottom:10px;">
        ≪解約について≫
      </h5>
      <p class="mb-0">解約のお申し込みは、申込ページまたは各塾の『設定』ページからお客様自身で行ってください。</p>
      <p class="mb-0">解約のお申し込みは、各月25日までに行われた場合は、当月末までのご利用となります。</p>
      <p class="mb-0">26日～末日までのお申し込みは、翌月1日受付となり、翌月末までのご利用となります。</p>
      <p class="mb-0">（翌月分まで請求が発生します）</p>

      <!-- お申し込みからID・パスワードの発行まで -->
      <h5 class="mt-8" style="margin-bottom:10px;">
        ≪お申し込みからID・パスワードの発行まで≫
      </h5>
      <p class="mb-0">申し込み後、「申込完了」の自動メールが、入力されたメールアドレスに届きます。</p>
      <p class="mb-0">弊社にて登録完了後、入力された教室のメールアドレスにID・パスワード等が記載されたメールが届きます。（お申し込みいただいてから5営業日以内）</p>
      <p class="mb-0">※弊社営業日となりますので、祝日等がある場合は1週間以上届かない場合もございます</p>
      <p class="mb-0">届いたメールには、URL・ID・パスワードが記載されていますので大切に保管してください。</p>

      <!-- サンプル・動作環境について -->
      <h5 class="mt-8" style="margin-bottom:10px;">
        ≪サンプル・動作環境について≫
      </h5>
      <p class="mb-0">サンプルは
        <router-link
          class="mt-10 env-check__link"
          to="/sign_in"
          target="_blank"
        >こちら</router-link>をご確認ください。
      </p>
      <p class="mb-0 ml-3">ID・パスワード：0（半角数字『ゼロ』）</p>
      <p class="mb-0">動作環境は、以下の通りです。</p>
      <p class="mb-0 ml-3">OS：Windows11、Mac OS X 10.10以上</p>
      <p class="mb-0">ブラウザ：Microsoft Edge、Google Chrome（推奨ブラウザ）</p>
      <p class="mb-0">ご使用中の機器の動作環境の確認は
        <router-link
          class="mt-10 env-check__link"
          to="/env_check"
          target="_blank"
        >こちら</router-link>でご確認ください。
      </p>

      <!-- 利用規約 -->
      <h5 class="mt-8" style="margin-bottom:10px;">
        ≪利用規約について≫
      </h5>
      <p style="margin-bottom:5px;">
        下記「利用規約」をご確認いただきお申し込みください。
        <br />
        ※お申し込みをもって利用規約に同意されたものとさせていただきます。
      </p>
      <v-row>
        <v-col cols="12" class="policy" ref="policy">
          <p>
            <span class="font-weight-bold"
              >ゲットスルー2600システム サービス利用規約
            </span>
            <br />
            <br />
            <span class="font-weight-bold">（ 本規約の範囲および変更 ）</span>
            <br />
            <font style="margin-right:10px">第1条</font>本規約は、株式会社エデュケーショナルネットワーク（以下「当社」という）が、インターネット上で提供する各種遠隔教育コンテンツのサービス（以下「コンテンツ」という）を、次条で定義する会員がコンテンツを利用することに伴う、当社と会員において適用されるものとします。<br>
            2. コンテンツの範囲は、会員と当社との間で別途契約した内容に準ずるものとします。<br>
            3. 当社は、必要に応じ会員の承諾なしに本規約の変更または新たな規定を追加できるものとします。<br>
            4. 会員は、当社からオンラインあるいはその他の方法で提示される運用規定またはその他の諸規定の追加および変更を承諾するものとし、またそれらは本規約の一部を構成するものとします。
            <br />
            <br />
            <span class="font-weight-bold">（ 定義 ）</span>
            <br />
            <font style="margin-right:10px">第2条</font>「会員」とは、本規約に従って所定の申請を行い、当社が承認した、学習塾や学校等のスクール事業を営む個人および法人とします。<br />
            2. 「会員ID・パスワード」とは、会員に対して当社が発行する、本コンテンツを利用するためのID・パスワードとします。
            <br />
            <br />
            <span class="font-weight-bold">（ 会員 ）</span>
            <br />
            <font style="margin-right:10px">第3条</font>加入希望者は、申し込みフォームにおいて、必要事項を入力し、加入申込をした時点で、本規約の内容を承諾したものとします。<br />
            2. 当社は、次の場合を除き、加入希望者の申請を承諾するものとします。<br />
            ( 1 )申込内容に虚偽の申請があった場合。<br />
            ( 2 )当社が会員として不適切と判断した場合。
            <br />
            <br />
            <span class="font-weight-bold"
              >（ 会員ID・パスワードの発行・管理 ）</span
            >
            <br />
            <font style="margin-right:10px">第4条</font>当社は申込受理日から５営業日以内に電子メールで会員IDおよびパスワードを発行します。<br />
            2. 会員ID・パスワードについては、会員が責任をもって管理するものとします。<br />
            3. 当社は、会員ID・パスワードの使用上の過失ならびに第三者の利用による会員の損害については、一切の責任を負わないものとします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 使用料の支払いと契約期間 ）
            </span>
            <br />
            <font style="margin-right:10px">第5条</font>会員は「コンテンツ」の利用に対し、定められた金額を、当社の定める支払方法によって支払うものとします。<br />
            2. 契約期間は、月額の場合は毎月1日～末日まで、年額の場合は会員ID・パスワードを発行した日の含まれる月から12ヶ月間とします。使用料については、別途定める条件がある場合を除き、月額の場合は末日までの使用料を翌月払い、年額の場合は会員ID・パスワードが発行された月の月末締め・翌月払いにて当社に支払うものとします。<br />
            3. 解約の場合、会員は本規約第11条に定める方法で当社に届け出るものとします。会員から退会・解約の申し出が無い場合、自動継続とします。<br />
            4. 会員は、申込後8日以内は、書面によって申込を撤回し、また契約を解除することができるものとします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 個人登録情報 ）
            </span>
            <br />
            <font style="margin-right:10px">第6条</font>会員は、加入時の全ての登録情報（専用フォームに入力した情報）に関して、いかなる虚偽の申告はしないものとします。<br />
            2. 会員は、その登録情報に変更が生じた場合、速やかに電子メール、電話等の手段により、当社に届け出るものとします。また、当社から会員に対し、登録情報の追加要請があった場合も同様とします。<br />
            3. 当社は、コンテンツの提供を通じて収集した会員の個人情報に関し、コンテンツ提供業務を遂行するうえで必要な範囲内で、自ら利用します。個人情報の取扱については、当社ウェブサイト（https://www.e-network.jp/company/privacy.html）に公開の「個人情報保護方針」に準ずるものとします。<br />
            また、以下の各号に定める場合に利用することがあります。<br />
            ( 1 ) 当社が、コンテンツの追加または変更のご案内、または緊急連絡の目的で、電子メールや郵便などで通知する場合。<br />
            ( 2 ) 当社が、コンテンツに対するご意見やご感想のご提供をお願いする場合。<br />
            ( 3 ) 当社が、コンテンツに関する利用動向を把握する目的で、会員情報の統計分析を行い、個人を識別できない形式に加工して、利用または提供する場合。<br />
            ( 4 ) コンテンツの提供のための環境設定およびメンテナンスなどを委託する第三者に、業務に必要な情報を提供する場合。<br />
            ( 5 ) 当社が所属するグループ各社の情報および商品サービス等のご紹介をさせていただく場合。<br />
            ( 6 ) 別途連絡のうえ、当社が個別にご了解を得た目的に利用する場合。<br />
            ( 7 ) 法律により開示が要求される場合。<br />
            4. 当社は、本条第3項に定める目的以外での利用はいたしません。<br />
            個人情報が第三者に漏洩することのないように、管理・保管するように努力するものとします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 会員の禁止行為 ）
            </span>
            <br />
            <font style="margin-right:10px">第7条</font>当社は、コンテンツの利用にあたり、会員の次の行為を禁止します。<br />
            ( 1 ) 公序良俗に反する行為。<br />
            ( 2 ) 法令に違反する行為。<br />
            ( 3 ) 犯罪に結びつく行為。<br />
            ( 4 ) 選挙運動もしくはこれに類似する行為および公職選挙法に抵触する行為。<br />
            ( 5 ) 他の会員および第三者の著作権その他知的財産権を侵害する行為。<br />
            ( 6 ) 他の会員および第三者を誹謗、中傷しその他名誉を毀損する行為。<br />
            ( 7 ) 他の会員および第三者の財産、プライバシーを侵害する行為。<br />
            ( 8 ) 他の会員および第三者に不利益を与える行為。<br />
            ( 9 ) 当社ホームページおよびコンテンツの運営を妨害する行為（情報の改ざん、ウイルス等の入力、送信など）、また、当社が不適切と判断する行為。<br />
            ( 10 ) 一種類のID・パスワードで、同時に複数の端末でコンテンツを利用する行為。<br />
            ( 11 ) 当社に無断で「ゲットスルー2600」という商標を使用し、サービスに供する行為。<br />
            ( 12 ) 当社に無断で「ゲットスルー2600」の二次（再）配布・譲渡、販売、改変、無断転載、二次利用、直リンクを供する行為。<br />
            ( 13 ) 会員が運営する学習塾等に属さない人以外（事業者等）にID・パスワードを利用させる行為。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 違約金 ）
            </span>
            <br />
            <font style="margin-right:10px">第8条</font>前条( 9 )の行為が当社の定期的に実施するログ解析等により判明した場合、直ちに会員資格が解除となると同時に、会員は本来の使用料の3倍に相当する額の違約金を支払い、当社になお回復し得ない損害がある場合はその賠償にも応ずるものとします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ コンテンツの中断・停止および内容の変更等 ）
            </span>
            <br />
            <font style="margin-right:10px">第9条</font>会員が、次の項目のいずれかに該当した場合、当社は、会員への事前の承諾なしに、そのコンテンツの利用停止または会員資格の抹消を行うことができるものとします。<br />
            ( 1 ) システムトラブルなどで緊急な保守点検が必要なとき。<br />
            ( 2 ) 第一種（電話会社等）および第二種電気通信事業者（プロバイダー）の役務が提供されないとき。<br />
            ( 3 ) 天災、地変、火災、停電などでコンテンツの提供ができないとき。<br />
            ( 4 ) 人為的災害（戦争、暴動、争乱、労働争議など）によりコンテンツの提供ができないとき。<br />
            ( 5 ) 会員が本規約に違反すると疑われると判断されたとき。<br />
            ( 6 ) その他、当社が必要と判断したとき。<br />
            2. 当社は、提供するコンテンツの内容の全部または一部について、会員の承諾をうけることなく、変更、追加または削除を行うことができるものとします。<br />
            3. 第1項に掲げる事態が発生し、会員に不利益、損害が生じた場合においても、当社は会員に対し、その責任を負わないものとします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 会員資格の停止及び資格の抹消 ）
            </span>
            <br />
            <font style="margin-right:10px">第10条</font>会員が、次の項目のいずれかに該当した場合、当社は、会員への事前の承諾なしに、そのコンテンツの利用停止または会員資格の抹消を行うことができるものとします。<br />
            ( 1 ) 所定の使用料の支払いを怠ったとき。<br />
            ( 2 ) 会員ID・パスワードを不正使用したとき。<br />
            ( 3 ) 加入申請内容に虚偽の事項があったとき。<br />
            ( 4 ) 当社ホームページおよびコンテンツの情報を改ざん、不正利用し、その他運営を故意に妨害したとき。<br />
            ( 5 ) 会員資格に不適当で抹消が必要と当社が判断したとき。<br />
            ( 6 ) その他、本規約に違反したとき。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 会員の退会・解約 ）
            </span>
            <br />
            <font style="margin-right:10px">第11条</font>会員は随時退会できるものとします。但し、第5条に定める契約期間の未経過分に関して、当社は清算（返金）する義務を有しないものとします。また、未払いの使用料がある場合、会員はこれを一括で支払うものとします。<br />
            2. 会員は退会を希望する場合、お客様自身により解約申し込みを行うものとします。<br />
            3. 第2項の申し込みが、各月25日までに行われない場合、事務処理手続上退会日は翌月1日とします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 損害の免責 ）
            </span>
            <br />
            <font style="margin-right:10px">第12条</font>当社は、コンテンツの利用により発生した会員の損害については、一切賠償の責は負わないものとします。<br />
            2. 会員がコンテンツを利用することにより、第三者に対して損害を与えた場合、会員は自己の責任により解決するものとします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 専属的合意管轄 ）
            </span>
            <br />
            <font style="margin-right:10px">第13条</font>会員と当社との間で本規約について訴訟の必要が生じた場合、東京地方裁判所あるいは東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
            <br />
            <br />
            <span class="font-weight-bold">
              （ 誠実協議 ）
            </span>
            <br />
            <font style="margin-right:10px">第14条</font>本規約の各条項に定めない事項が生じた場合には、当社と会員で協議のうえこれを定めます。
          </p>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-btn
          color="#D65B5B"
          @click.stop="returnTop"
          dark
          >同意しない</v-btn
        >
        <v-btn
          class="ml-2"
          color="secondary"
          :disabled="disabled"
          @click.stop="$router.push('/enrollment/new')"
          >同意する</v-btn
        >
      </v-row>
    </template>
  </v-base-card>
</template>

<script>

import enrollmentMixin from "@/mixins/enrollment";
import VBaseCard from '@/components/molecules/BaseCard'

export default {
  mixins: [enrollmentMixin],
  components: {
    VBaseCard,
  },
  data() {
    return {
      checkbox: false,
      disabled: true,
    }
  },
  mounted() {
    this.$refs["policy"].addEventListener('scroll', this.scroll)
  },
  beforeDestroy() {
    this.$refs["policy"].removeEventListener('scroll', this.scroll)
  },
  methods: {
    scroll() {
      if (this.$refs["policy"].scrollTop >= 900) this.disabled = false
    }
  }
}
</script>

<style lang="stylus" scoped>

h5
  color #0079e8

p
  font-size 13px

.policy
  overflow auto
  height 480px
  border solid 1px #808080
  margin 2px

.env-text
  color red
  font-size 14px

.link-text
  color #3e63d0

.env-check__link
  color #6185f5
</style>
